import React from 'react';
import { Header } from './components/Header';
import { MemberDataProvider } from './context/MemberDataContext';
import { FirstAccessForm } from './FirstAccessForm';
import { ConstantProvider } from './context/ConstantsContext';
import { EmailRecaptchaProvider } from './context/EmailRecaptchaContext';
import { EmailSharedValidationProvider } from './context/EmailSharedValidationContext';

export function FirstAccessFlow() {
  return (
    <MemberDataProvider>
      <EmailRecaptchaProvider>
        <EmailSharedValidationProvider>
          <ConstantProvider>
            <main className="first-access-container gol-sans" data-testid="first-access-main">
              <Header />
              <section>
                <FirstAccessForm />
              </section>
            </main>
          </ConstantProvider>
        </EmailSharedValidationProvider>
      </EmailRecaptchaProvider>
    </MemberDataProvider>
  );
}
